/* Tracking Status client data model
 *
 *  TrackingStatus class.
 */

class TrackingStatus {
    constructor(tsId, tsName, isApproved, isReported) {
        if (Number.isInteger(tsId) && (tsId > 0)) {
            this.trackingStatusId = tsId;
        }
        else {
            throw new TypeError("Invalid Tracking Status Id");
        }

        if ((angular.isString(tsName)) &&
            (tsName.length > 0))
        {
            this.trackingStatusName = tsName;
        }
        else {
            throw new TypeError("Invalid Tracking Status Name");
        }

        this.isApproved = false;
        if ((isApproved != null) &&
            (typeof(isApproved) === "boolean"))
        {
            this.isApproved = isApproved;
        }

        this.isReported = false;
        if ((isReported != null) &&
            (typeof(isReported) === "boolean"))
        {
            this.isReported = isReported;
        }
    }

    toString() {
        return `${this.trackingStatusName} (${this.trackingStatusId})`;
    }

    valueOf() {
        return this.trackingStatusId;
    }

    static Copy(otherTrackingStatus) {
        if (otherTrackingStatus != null)
        {
            return new TrackingStatus(
                otherTrackingStatus.trackingStatusId,
                otherTrackingStatus.trackingStatusName,
                otherTrackingStatus.isApproved,
                otherTrackingStatus.isReported
            );
        }
        else {
            throw new TypeError("TrackingStatus Copy: source is null or undefined");
        }
    }

    static FromServerTrackingStatus(serverTrackingStatus) {
        if (serverTrackingStatus != null) {
            return new TrackingStatus(
                serverTrackingStatus.TrackingStatusId,
                serverTrackingStatus.TrackingStatusName,
                serverTrackingStatus.IsApproved,
                serverTrackingStatus.IsReported
            );
        }

        return null;
    }

}

export default TrackingStatus;


//////////////////
// WEBPACK FOOTER
// ./src/models/TrackingStatus.js
// module id = TsI0
// module chunks = 1